import {
    registerMsgHandler,
    registerErrorMsgHandlerByMsgDefinition,
} from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    NOTIFY_PASSPORT_UPDATE,
    RESPOND_ADD_PASSPORT,
    RESPOND_LIST_PASSPORTS,
    RESPOND_REMOVE_PASSPORT,
    RESPOND_UPDATE_PASSPORT,
    NOTIFY_MAPPING_UPDATE,
    NOTIFY_MAPPING_REMOVED,
    RESPOND_ADD_MAPPING,
    RESPOND_LIST_MAPPINGS,
    RESPOND_REMOVE_MAPPING,
    RESPOND_UPDATE_MAPPING,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/everbridgeMsgDefinitions";
import {
    EverbridgeMapping,
    EverbridgeMappingID,
    EverbridgePassport,
    EverbridgePassportHeader,
    EverbridgePassportID,
    EverbridgePassportState,
} from "userful-chronos-app-common-js/dist/models/integration/everbridge";
import integrationStore from "../integrationStore";
import { everbridgeActions } from "../everbridgeSlice";

const toIsoString = (value: unknown): string | null => {
    if (value === null || value === undefined) {
        return null;
    }

    if (typeof value === "string") {
        return value;
    }

    if (typeof value === "number") {
        return new Date(value).toISOString();
    }

    if (typeof value === "object") {
        const epochMillis = (value as { epochMillis?: number }).epochMillis;
        if (typeof epochMillis === "number") {
            return new Date(epochMillis).toISOString();
        }
    }

    return null;
};

const normalizePassportState = (state: EverbridgePassportState | undefined): EverbridgePassportState | undefined => {
    if (!state) {
        return undefined;
    }

    return {
        ...state,
        lastPollTime: toIsoString(state.lastPollTime as unknown),
        lastIncidentTime: toIsoString(state.lastIncidentTime as unknown),
    };
};

const normalizePassport = (passport: EverbridgePassport): EverbridgePassport => ({
    ...passport,
    filters: passport.filters ?? [],
    state: normalizePassportState(passport.state),
});

registerMsgHandler(RESPOND_LIST_PASSPORTS, (payload) => {
    const data = JSON.parse(payload) as EverbridgePassport[];
    integrationStore.dispatch(everbridgeActions.setPassports(data.map(normalizePassport)));
});

registerMsgHandler(RESPOND_ADD_PASSPORT, (payload) => {
    JSON.parse(payload) as EverbridgePassportHeader;
    integrationStore.dispatch(everbridgeActions.changeLoadState("RENDER"));
    integrationStore.dispatch(everbridgeActions.setOpenForm(false));
    integrationStore.dispatch(everbridgeActions.getPassportsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_ADD_PASSPORT, () => {
    integrationStore.dispatch(everbridgeActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_PASSPORT, (payload) => {
    JSON.parse(payload) as EverbridgePassportHeader;
    integrationStore.dispatch(everbridgeActions.changeLoadState("RENDER"));
    integrationStore.dispatch(everbridgeActions.setOpenForm(false));
    integrationStore.dispatch(everbridgeActions.getPassportsFromServer());
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_PASSPORT, () => {
    integrationStore.dispatch(everbridgeActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_REMOVE_PASSPORT, (payload) => {
    const data = JSON.parse(payload) as EverbridgePassportID;
    integrationStore.dispatch(everbridgeActions.removePassport(data));
});

registerMsgHandler(NOTIFY_PASSPORT_UPDATE, (payload) => {
    const data = JSON.parse(payload) as EverbridgePassport;
    integrationStore.dispatch(everbridgeActions.addOrUpdatePassport(normalizePassport(data)));
});

registerMsgHandler(RESPOND_LIST_MAPPINGS, (payload) => {
    const data = JSON.parse(payload) as EverbridgeMapping[];
    integrationStore.dispatch(everbridgeActions.setMappings(data));
});

registerMsgHandler(RESPOND_ADD_MAPPING, () => {
    integrationStore.dispatch(everbridgeActions.changeMappingLoadState("RENDER"));
    integrationStore.dispatch(everbridgeActions.setMappingOpenForm(false));
    integrationStore.dispatch(everbridgeActions.getMappingsFromServer(undefined));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_ADD_MAPPING, () => {
    integrationStore.dispatch(everbridgeActions.changeMappingLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_MAPPING, () => {
    integrationStore.dispatch(everbridgeActions.changeMappingLoadState("RENDER"));
    integrationStore.dispatch(everbridgeActions.setMappingOpenForm(false));
    integrationStore.dispatch(everbridgeActions.getMappingsFromServer(undefined));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_MAPPING, () => {
    integrationStore.dispatch(everbridgeActions.changeMappingLoadState("RENDER"));
});

registerMsgHandler(RESPOND_REMOVE_MAPPING, (payload) => {
    const data = JSON.parse(payload) as EverbridgeMappingID;
    integrationStore.dispatch(everbridgeActions.removeMapping(data));
});

registerMsgHandler(NOTIFY_MAPPING_UPDATE, (payload) => {
    const data = JSON.parse(payload) as EverbridgeMapping;
    integrationStore.dispatch(everbridgeActions.addOrUpdateMapping(data));
});

registerMsgHandler(NOTIFY_MAPPING_REMOVED, (payload) => {
    const data = JSON.parse(payload) as EverbridgeMappingID;
    integrationStore.dispatch(everbridgeActions.removeMapping(data));
});
